<template>
  <div>
    <div v-if="!hasAcceptedPolicy" class="legal-documents__buttons">
      <div class="legalDocuments" v-html="$sanitize(decodeLegalDocs(policyDocument))"></div>
      <div class="buttons-wrapper">
        <cactus-button :isPrimary="true" @btnClicked="updateProfilePolicy">
          {{ $t('Web.LegalDocuments.Buttons.Accept') }}
        </cactus-button>
        <div class="secondary">
          <cactus-sign-out>
            <span slot="body">{{ $t('Web.LegalDocuments.Buttons.Decline') }}</span>
          </cactus-sign-out>
        </div>
      </div>
    </div>

    <div v-if="hasAcceptedPolicy && !hasAcceptedTerms" class="legal-documents__buttons">
      <div
        class="legalDocuments"
        v-html="$sanitize(decodeLegalDocs(termsAndConditionDocument))"
      ></div>
      <div class="buttons-wrapper">
        <cactus-button class="primary" @btnClicked="updateProfileTermsAndCondition">
          {{ $t('Web.LegalDocuments.Buttons.Accept') }}
        </cactus-button>
        <div class="secondary">
          <cactus-sign-out>
            <span slot="body">{{ $t('Web.LegalDocuments.Buttons.Decline') }}</span>
          </cactus-sign-out>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import _has from 'lodash/has';
import CactusButton from '../_common/cactusButton';

export default {
  name: 'legalDocuments',
  components: { CactusButton },
  data() {
    return {};
  },

  methods: {
    ...mapActions(['updateProfile']),

    updateProfilePolicy() {
      const profileObj = this.getProfileObject();

      profileObj.privacy_policy = this.policyKey.latest;

      Promise.all([this.updateProfile(profileObj)]).then(() => {
        this.$store.dispatch('setHasPolicyAccepted', true);
      });
    },

    updateProfileTermsAndCondition() {
      const profileObj = this.getProfileObject();

      profileObj.terms_and_conditions = this.tcKey.latest;

      Promise.all([this.updateProfile(this.$sanitize(JSON.stringify(profileObj)))]).then(() => {
        this.$store.dispatch('setHasTermAccepted', true);
      });
    },

    decodeLegalDocs(response) {
      if (_has(response.data, 'html')) {
        try {
          const content = atob(response.data.html);
          return decodeURIComponent(escape(content));
        } catch (e) {
          return 'Fehler. Es wird kein valides Dokument ausgeliefert.';
        }
      }
    },

    getProfileObject() {
      return {
        ...this.profile,
        news: this.profile.news,
        electricity_price: this.profile.electricity_price,
        terms_and_conditions: this.profile.terms_and_conditions,
        privacy_policy: this.profile.privacy_policy,
        allow_data_usage: _has(this.profile, 'allow_data_usage')
          ? this.profile.allow_data_usage
          : true,
        last_name: _has(this.profile, 'last_name') ? this.profile.last_name : '',
        first_name: _has(this.profile, 'first_name') ? this.profile.first_name : '',
        anonymize_private_data: _has(this.profile, 'anonymize_private_data')
          ? this.profile.anonymize_private_data
          : false
      };
    }
  },

  computed: {
    ...mapGetters([
      'isAuthenticated',
      'hasAcceptedPolicy',
      'hasAcceptedTerms',
      'profile',
      'policyKey',
      'tcKey',
      'policyDocument',
      'termsAndConditionDocument'
    ])
  }
};
</script>

<style lang="scss">
.buttons-wrapper {
  margin: 0 auto;
  padding: 40px 0 60px 0;
  width: $maxWidth;
  text-align: center;

  & > button {
    margin-bottom: 20px;
  }

  .secondary,
  .secondary button {
    background: none;
    color: $charcoal-grey;
  }
}

.legalDocuments {
  font-family: $font-siemens;

  h1 {
    margin: 0 auto;
    text-align: center;
    font-size: 24px;
  }

  h2,
  h3 {
    margin: 48px 0 20px;
    color: $charcoal-grey;
    font-size: 24px;
  }

  ul {
    margin-left: 15px;

    & > li {
      list-style: disc;
    }
  }

  p {
    margin: 15px 0;
  }

  li {
    margin: 0 0 0 15px;
  }

  &__body {
    padding: 0 10px 30px 10px;
    font-size: 16px;

    h1 {
      display: none;
    }
  }
}
</style>
